<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllStockTransfer('printStockTransfer')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockTransfer()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="serialNo"
                label="Serial No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="requestNo"
                label="Request No"
                type="text"
                v-model="queryParams.requestNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockTransferStatusList"
                label="Choose Stock Transfer Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="transferTypeList"
                label="Choose Stock Transfer Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.transferType"
              ></v-select>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN'">
              <v-autocomplete
                v-model="queryParams.fromWarehouseId"
                :items="warehouseList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN'">
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose To Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.toWarehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'WAREHOUSE_MANAGER' ||
                user.role.roleName == 'WAREHOUSE_STAFF' ||
                user.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-select
                :items="typeList"
                label="Choose Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="type"
                v-on:change="changeType()"
              ></v-select>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'WAREHOUSE_MANAGER' ||
                user.role.roleName == 'WAREHOUSE_STAFF' ||
                user.role.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockTransferList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.serialNo }}</td>
              <td>{{ props.item.requestNo }}</td>
              <td>{{ props.item.fromWarehouseName }}</td>
              <td>{{ props.item.fromBinName }}</td>
              <td>{{ props.item.toWarehouseName }}</td>
              <td>{{ props.item.toBinName }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn
                  color="primary"
                  @click.stop="reprintStockTransferInvoice(props.item.id)"
                  >REPRINT</v-btn
                >
              </td>
              <td>
                <v-btn color="success" @click.stop="exportExcel(props.item.id)"
                  >EXPORT</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <stockTransferExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></stockTransferExcel>
    <!-- print all -->
    <div
      id="printStockTransfer"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock Transfer Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ this.queryParams.fromDate | formatDate }}] To Date: [{{
            this.queryParams.toDate | formatDate
          }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 14px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead style="border: 1px solid black">
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Issue Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Issue No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Serial No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Request No
              </th>
              <th style="border: 1px solid black; text-align: center">
                From Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">
                From Bin
              </th>
              <th style="border: 1px solid black; text-align: center">
                To Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">
                To Bin
              </th>
              <th style="border: 1px solid black; text-align: center">
                Stock Transfer Type
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody style="border: 1px solid black">
            <tr v-for="(item, index) in allStockTransferList" :key="index">
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.issueNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.serialNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.requestNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.fromWarehouseName }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
                v-if="item.fromBinName"
              >
                {{ item.fromBinName }}
              </td>
              <td valign="top" style="border: 1px solid black" v-else></td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.toWarehouseName }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
                v-if="item.toBinName"
              >
                {{ item.toBinName }}
              </td>
              <td valign="top" style="border: 1px solid black" v-else></td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.type }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 2rem"
                  v-for="detail in item.stockTransferItems"
                  :key="detail"
                >
                  {{ detail.productName + "(" + detail.productCode + ")" }}
                  <br />
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: center"
              >
                <div
                  style="height: 2rem"
                  v-for="detail in item.stockTransferItems"
                  :key="detail"
                >
                  {{ detail.factorUnitName }} <br />
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: right"
              >
                <ul style="list-style-type: none">
                  <li
                    style="height: 2rem"
                    v-for="detail in item.stockTransferItems"
                    :key="detail"
                  >
                    {{ detail.qty | decFormat(6) }}
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockTransferService } from "../../services/stock-transfer-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockTransferExcel from "../../components/stock-transfer/StockTransferExcel";

export default {
  name: "StockTransferList",

  components: { stockTransferExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock Transfer",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Serial No", value: "serialNo" },
      { text: "Request No", value: "requestNo" },
      { text: "From Warehouse", value: "fromWarehouse.name" },
      { text: "From Bin", value: "fromBinName" },
      { text: "To Warehouse", value: "toWarehouse.name" },
      { text: "To Bin", value: "toBinName" },
      { text: "Type", value: "type" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Reprint", align: "center", sortable: false },
      { text: "Export", align: "center", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    stockTransferStatusList: [],
    typeList: [
      { label: "TRANSFER", value: "TRANSFER" },
      { label: "RECEIVE", value: "RECEIVE" },
    ],
    transferTypeList: [
      { label: "----All----", value: "" },
      { label: "GOOD", value: "GOOD" },
      { label: "DAMAGE", value: "DAMAGE" },
      { label: "PURCHASE_RETURN", value: "PURCHASE_RETURN" },
    ],
    printAllButtonLoading: false,
    stockTransferList: [],
    allStockTransferList: [],
    warehouseList: [],
    openDialog: false,
    totalRows: 0,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      requestNo: "",
      status: "",
      fromWarehouseId: "",
      toWarehouseId: "",
      warehouseId: "",
      transferType: "",
      updateUserId: "",
      fromBinIds: [],
      toBinIds: [],
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTransferList();
      },
      deep: true,
    },
  },
  created() {
    if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.type = "TRANSFER";
      if (this.user.role.roleName == "WAREHOUSE_STAFF") {
        //this.queryParams.updateUserId = this.user.id;
      }
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.user.role.roleName == "ADMIN") {
      if (this.$route.query.fromWarehouseId) {
        this.queryParams.fromWarehouseId = Number(this.$route.query.fromWarehouseId);
      }
      if (this.$route.query.toWarehouseId) {
        this.queryParams.toWarehouseId = Number(this.$route.query.toWarehouseId);
      }
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.requestNo) {
      this.queryParams.requestNo = this.$route.query.requestNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.transferType) {
      this.queryParams.transferType = this.$route.query.transferType;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.onSearch();
    this.changeType();
  },
  methods: {
    onSearch() {
      this.queryParams.fromBinIds = [];
      this.queryParams.toBinIds = [];
      if (
        this.user.role.roleName == "WAREHOUSE_MANAGER" ||
        this.user.role.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "BRANCH_ADMIN"
      ) {
        if (this.type === "TRANSFER") {
          this.queryParams.fromWarehouseId = this.user.warehouseId;
          this.queryParams.toWarehouseId = this.queryParams.warehouseId;
          if (this.user.roleName == "WAREHOUSE_STAFF") {
            this.user.selectedBinList.forEach((v) =>
              this.queryParams.fromBinIds.push(v.id)
            );
          }
        }
        if (this.type === "RECEIVE") {
          this.queryParams.toWarehouseId = this.user.warehouseId;
          this.queryParams.fromWarehouseId = this.queryParams.warehouseId;
          if (this.user.roleName == "WAREHOUSE_STAFF") {
            this.user.selectedBinList.forEach((v) =>
              this.queryParams.toBinIds.push(v.id)
            );
          }
        }
      }

      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-transfers",
        query: this.queryParams,
      });
      this.getStockTransferList();
    },
    changeType() {
      if (this.type === "TRANSFER" || this.user.roleName == "ADMIN") {
        this.stockTransferStatusList = [];
        this.stockTransferStatusList.push(
          "DRAFT",
          "DELIVERY",
          "FINISHED",
          "CANCEL"
        );
      }
      if (this.type === "RECEIVE") {
        this.stockTransferStatusList = [];
        this.stockTransferStatusList.push("DELIVERY", "FINISHED");
      }
    },

    getStockTransferList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTransferService
        .getStockTransferList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTransferList = res.data.stockTransferList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onRegister() {
      this.$router.push("/stock-transfer/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockTransferList();
    },
    onEdit(stockTransfer) {
      // go to details page
      this.$router.push("/stock-transfer/" + stockTransfer.id);
    },
    reprintStockTransferInvoice(id) {
      stockTransferService.printStockTransferInvoice(id).then((res) => {
        var blob = res;
        commonService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    exportExcel(id) {
      stockTransferService
        .exportStockTransferExcel(id)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printAllStockTransfer(divName) {
      this.printAllButtonLoading = true;
      stockTransferService
        .getAllStockTransferList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allStockTransferList = res.data.stockTransferList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllStockTransfer() {
      this.printAllButtonLoading = false;
      stockTransferService
        .exportAllStockTransferExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>